<template>
    <div class="group-div">
        <button class="setting-btn" v-if="card.cardSetting.isShowPhone == -1" @click="changePhoneStatus(0)">
            <font-awesome-icon icon="fa-solid fa-phone-slash" />
        </button>

        <button class="setting-btn" v-if="card.cardSetting.isShowPhone == null || card.cardSetting.isShowPhone == 0" @click="changePhoneStatus(-1)">
            <font-awesome-icon icon="fa-solid fa-phone" />
        </button>

        <button class="setting-btn" v-if="card.cardSetting.isShowCard == -1" @click="changeVisibleStatus(0)">
            <font-awesome-icon icon="fa-solid fa-eye-slash" />
        </button>

        <button class="setting-btn" v-if="card.cardSetting.isShowCard == null || card.cardSetting.isShowCard == 0" @click="changeVisibleStatus(-1)">
            <font-awesome-icon icon="fa-solid fa-eye" />
        </button>
    </div>
</template>

<script setup>
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faPhone, faPhoneSlash, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

    const props = defineProps(['card'])
    const emits = defineEmits(['saveCardChange'])

    library.add(faPhone, faPhoneSlash, faEye, faEyeSlash)
    
    function changePhoneStatus(value) {
        emits("saveCardChange", {
            isShowPhone: value
        })
    }

    function changeVisibleStatus(value) {
        emits("saveCardChange", {
            isShowCard: value
        })
    }
</script>

<style scoped>
    .group-div {
        display: flex;
    }

    .setting-btn {
        font-size: 20px;
        /*margin-right: 10px;*/
        background-color: #FFFF;
        border: 0;
        cursor: pointer;
        transition: 0.25s all ease;
        color: #303133;
    }

    .setting-btn:hover {
        color: #c45656;
    }
</style>